import { emptySplitApi } from './index'

export const countryApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCountryList: builder.query({
        query: (model) => ({
            url: `api/v1/auth-service/country`,
            method: "GET"
        }),
    }),
    getCountryByCode: builder.query({
        query: (model) => ({
            url: `api/v1/auth-service/country/${model.countryCode}`,
            method: "GET"
        }),
    }),
    getCountryByCodeWithTrigger: builder.mutation({
        query: (model) => ({
            url: `api/v1/auth-service/country/${model.countryCode}`,
            method: "GET"
        }),
    }),
    getCountryOnlyList: builder.query({
        query: (model) => ({
            url: `api/v1/auth-service/country/country-only`,
            method: "GET"
        }),
    }),
    getCountyOnlyList: builder.query({
        query: (model) => ({
            url: `api/v1/search-engine-service/country/counties`,
            method: "GET"
        }),
    }),
    getCityListByProvinceOrStates: builder.mutation({
        query: (model) => ({
            url: `api/v1/auth-service/country/city-list`,
            method: "POST",
            body: model
        }),
    }),
    getCityListByProvinceOrStates2: builder.query({
        query: (model) => ({
            url: `api/v1/auth-service/country/city-list`,
            method: "POST",
            body: model
        }),
        transformResponse: (response) => response.map(item => ({
            id: item.id,
            label: item.name,
            value: item.name,
            secondaryAction: item.provinceOrStateCode,
        }))
    }),
    getProvinceOrStateListByCountryCodes: builder.mutation({
        query: (countryCodes) => ({
            url: `api/v1/auth-service/country/province-state-list`,
            method: "POST",
            body: [...countryCodes]
        }),
    }),
    getProvinceOrStateListByCountryCodes2: builder.query({
        query: (countryCodes) => ({
            url: `api/v1/auth-service/country/province-state-list`,
            method: "POST",
            body: [...countryCodes]
        }),
        transformResponse: (response) => response.map(item => ({
            id: item.code,
            label: item.description,
            value: item.code,
        }))
    }),
    getForeignStates: builder.mutation({
        query: (countryCode) => ({
            url: `api/v1/auth-service/country/foreign-states/${countryCode}`,
            method: "GET",
        }),
    }),
    getForeignStates2: builder.query({
        query: (countryCode) => ({
            url: `api/v1/auth-service/country/foreign-states/${countryCode}`,
            method: "GET",
        }),
    }),
    getCountiesByState: builder.mutation({
        query: (stateCode) => ({
            url: `api/v1/auth-service/country/counties/${stateCode}`,
            method: "GET",
        }),
    }),
  }),
  overrideExisting: false,
});

export const { 
    useGetCountryListQuery,
    useGetCityListByProvinceOrStatesMutation,
    useGetCountryOnlyListQuery,
    useGetCountyOnlyListQuery,
    useGetProvinceOrStateListByCountryCodesMutation,
    useGetCountryByCodeQuery,
    useGetCountryByCodeWithTriggerMutation,
    useGetProvinceOrStateListByCountryCodes2Query,
    useGetCityListByProvinceOrStates2Query,
    useGetForeignStatesMutation,
    useGetForeignStates2Query,
    useGetCountiesByStateMutation,
} = countryApi;
